
import Form from "./Form.vue";
import IdentificadorData from "./IdentificadorData";
import { mapGetters } from "vuex";

export default {
  name: "app-identificador-create",
  data() {
    return {
      identificador: new IdentificadorData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
